export function getInvestigationComment(wrapper) {
  if (typeof wrapper?.comments === "string") {
    return wrapper.comments;
  }

  // The API stores the investigation comment on every observation. Joining
  // repeated copies makes it grow on every save/reopen cycle.
  const comments = (wrapper?.observations || [])
    .map((observation) => observation?.comments)
    .filter((comment) => typeof comment === "string" && comment.length > 0);

  return [...new Set(comments)].join("\n");
}

export function getResultEntrySaveError(error) {
  if (error?.response?.status === 413) {
    return "Results were not saved: the request is too large (413). Ask support to review oversized comments or templates for this appointment before retrying.";
  }

  return "Something went wrong!";
}
